export const GET_employees = ({ employees }) => employees
export const GET_states = ({ states }) => states
export const GET_maritalStatus = ({ maritalStatus }) => maritalStatus
export const GET_birthdays = ({ birthdays }) => birthdays
export const GET_contactMessagesWebSite = ({ contactMessagesWebSite }) => contactMessagesWebSite
export const GET_paycheck = ({ paycheck }) => paycheck
export const GET_employeePaycheck = ({ employeePaycheck }) => employeePaycheck
export const getEmployeeById = ({ employees }) => (id) => {
  return employees.find((employee) => employee.id == id)
}
export const getEmployeeExceptList = ({ employees }) => (except_list) => {
  return employees.filter((employee) => !except_list.includes(employee.id))
}
